var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"value":_vm.id,"placeholder":_vm.placeholder,"multiple":_vm.multiple,"filterable":"","clearable":_vm.clearable,"size":_vm.size},on:{"visible-change":_vm.visiblechange,"change":_vm.change}},_vm._l((_vm.list),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.userName,"value":item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }